<div class="content-principal" style="max-width: 1100px; margin: 100px auto ">
  <h1 style="margin: 40px; display: flex; justify-content: center;">
    Política de privacidad
  </h1>

  <div class="contenido" *ngFor="let faq of faqs; let i = index">
    <!-- <div class="row" (click)="desplegarRespuesta(i)"  > -->

    <div
      (click)="desplegarRespuesta(i)"
      class="row"
      *ngIf="!faq.estado"
      style="cursor:pointer"
    >
      <div
        class="col-10 texto"
        *ngIf="!faq.estado"
        style="margin-bottom: 10px;"
      >
        {{ faq.question }}
      </div>
      <div class="col-10 texto" *ngIf="faq.estado" style="color: #DCC59C;">
        {{ faq.question }}
      </div>

      <div class="col-2 icono">
        <!-- <fa-icon [icon]="chevronDown" *ngIf="!faq.estado"></fa-icon> -->
        <fa-icon [icon]="chevronDown"></fa-icon>
        <fa-icon
          [icon]="chevronUp"
          *ngIf="faq.estado"
          style="color: #DCC59C;"
        ></fa-icon>
      </div>
    </div>

    <div
      (click)="desplegarRespuesta(i)"
      class="row"
      *ngIf="faq.estado"
      style="border: none; cursor: pointer;"
    >
      <div class="col-10 texto" *ngIf="!faq.estado">
        {{ faq.question }}
      </div>
      <div class="col-10 texto" *ngIf="faq.estado" style="color: #DCC59C;">
        {{ faq.question }}
      </div>
      <div class="col-2 icono">
        <fa-icon [icon]="chevronDown" *ngIf="!faq.estado"></fa-icon>
        <fa-icon
          [icon]="chevronUp"
          *ngIf="faq.estado"
          style="color: #DCC59C;"
        ></fa-icon>
      </div>
    </div>
    <div *ngIf="faq.estado">
      <div [innerHTML]="faq.answer" [ngClass]="{ clase2: faq.estado }"></div>
    </div>
  </div>
</div>
<dc-footer1></dc-footer1>
